import { render, staticRenderFns } from "./IconFaq.vue?vue&type=template&id=7a9b8fcc&"
import script from "./IconFaq.vue?vue&type=script&lang=ts&"
export * from "./IconFaq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports